import { render, staticRenderFns } from "./CProduce.vue?vue&type=template&id=5dd1a94d"
import script from "./CProduce.vue?vue&type=script&lang=js"
export * from "./CProduce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports